import { Theme } from "../../components/constants";

export default {
    gridColumnText: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
    fileBoiDiv: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: "30px",
        gap: "15px",
    },
    gridActions: { 
      display: 'flex', 
      gap: '10px' 
	  },
    filtersContainer: {
      display: "flex",
      gap: "20px",
    },
    confirmationPopupCustomStyle: {
      maxWidth: "fit-content",
    }

}